import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { isSdfCardFlow } from '../../config/app-config';
import { UtilsService } from '../../services/utils.service';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-location-dialog',
  templateUrl: './app-location-dialog.component.html',
  styleUrls: ['./app-location-dialog.component.scss'],
})
export class AppLocationDialogComponent
  extends BaseComponent
  implements OnInit
{
  labels: any;
  google: any;
  flow: string;
  isMobile$: Observable<boolean>;
  isMobile: boolean;
  isSdfCardFlow = false;

  constructor(
    private dialogRef: MatDialogRef<AppLocationDialogComponent>,
    private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {
    super();
    this.isMobile$ = this.utilsService.isMobile;
    this.isMobile$.subscribe((mobile) => {
      this.isMobile = mobile;
      // console.log("IS MOBILE : ", mobile);
    });
    this.isSdfCardFlow = isSdfCardFlow;
  }

  ngOnInit() {
    if (this.dialogData && this.dialogData.params) {
      this.labels = this.dialogData.params.labels;
      this.google = this.dialogData.params.google;
      this.flow = this.dialogData.params.flow;
    }
    this.dialogRef.addPanelClass('custom-dialog-without-close');
  }

  // closeModal() {
  //   setTimeout(() => {
  //     this.dialogRef.close();
  //   }, 150);
  // }

  closeCancelModal() {
    this.dialogRef.close();
  }
}
